var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "md-file" },
    [
      _c("md-file-icon", {
        staticClass: "md-file-icon",
        class: _vm.iconClass,
        nativeOn: {
          click: function ($event) {
            return _vm.openPicker.apply(null, arguments)
          },
        },
      }),
      _vm._v(" "),
      {
        disabled: _vm.disabled,
        required: _vm.required,
        placeholder: _vm.placeholder,
      }.type === "checkbox"
        ? _c(
            "input",
            _vm._b(
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.model,
                    expression: "model",
                  },
                ],
                staticClass: "md-input",
                attrs: {
                  "aria-label": _vm.title,
                  readonly: "",
                  type: "checkbox",
                },
                domProps: {
                  checked: Array.isArray(_vm.model)
                    ? _vm._i(_vm.model, null) > -1
                    : _vm.model,
                },
                on: {
                  click: _vm.openPicker,
                  blur: _vm.onBlur,
                  change: function ($event) {
                    var $$a = _vm.model,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.model = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.model = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.model = $$c
                    }
                  },
                },
              },
              "input",
              {
                disabled: _vm.disabled,
                required: _vm.required,
                placeholder: _vm.placeholder,
              },
              false
            )
          )
        : {
            disabled: _vm.disabled,
            required: _vm.required,
            placeholder: _vm.placeholder,
          }.type === "radio"
        ? _c(
            "input",
            _vm._b(
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.model,
                    expression: "model",
                  },
                ],
                staticClass: "md-input",
                attrs: { "aria-label": _vm.title, readonly: "", type: "radio" },
                domProps: { checked: _vm._q(_vm.model, null) },
                on: {
                  click: _vm.openPicker,
                  blur: _vm.onBlur,
                  change: function ($event) {
                    _vm.model = null
                  },
                },
              },
              "input",
              {
                disabled: _vm.disabled,
                required: _vm.required,
                placeholder: _vm.placeholder,
              },
              false
            )
          )
        : _c(
            "input",
            _vm._b(
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.model,
                    expression: "model",
                  },
                ],
                staticClass: "md-input",
                attrs: {
                  "aria-label": _vm.title,
                  readonly: "",
                  type: {
                    disabled: _vm.disabled,
                    required: _vm.required,
                    placeholder: _vm.placeholder,
                  }.type,
                },
                domProps: { value: _vm.model },
                on: {
                  click: _vm.openPicker,
                  blur: _vm.onBlur,
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.model = $event.target.value
                  },
                },
              },
              "input",
              {
                disabled: _vm.disabled,
                required: _vm.required,
                placeholder: _vm.placeholder,
              },
              false
            )
          ),
      _vm._v(" "),
      _c(
        "input",
        _vm._g(
          _vm._b(
            {
              ref: "inputFile",
              attrs: { type: "file" },
              on: { change: _vm.onChange },
            },
            "input",
            _vm.attributes,
            false
          ),
          _vm.$listeners
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }